// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable unicorn/no-array-method-this-argument */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable eslint-comments/no-duplicate-disable */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-array-callback-reference */
/* eslint-disable guard-for-in */

import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Request, { ApiMode } from '../../utils/request';
import Modal from '../../components/Modal';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';

// class names
const SELECTOR_WRAPPER = '.p-activator-portal-my-activator-details-page';

const SECTION_CONFIG = {
	experience: {
		wrapper: '.js-activator-my-details-my-experience-section-wrapper',
		button: '.p-activator-portal-my-details_edit-experience-btn',
		stepsApiAttr: 'experience-steps-api',
		submitApiAttr: 'experience-submit-api'
	},
	sports: {
		wrapper: '.js-activator-my-details-my-sports-section-wrapper',
		button: '.p-activator-portal-my-details_edit-sports-btn',
		stepsApiAttr: 'sports-steps-api',
		submitApiAttr: 'sports-submit-api'
	},
	audience: {
		wrapper: '.js-activator-my-details-my-audience-section-wrapper',
		button: '.p-activator-portal-my-details_edit-audience-btn',
		stepsApiAttr: 'audience-steps-api',
		submitApiAttr: 'audience-submit-api'
	},
	venueType: {
		wrapper: '.js-activator-my-details-venue-type-section-wrapper',
		button: '.p-activator-portal-my-details_edit-venue-type-btn',
		stepsApiAttr: 'venue-type-steps-api',
		submitApiAttr: 'venue-type-submit-api'
	},
	venues: {
		wrapper: '.js-activator-my-details-my-venues-section-wrapper',
		button: '.p-activator-portal-my-details_add-venues-btn',
		stepsApiAttr: 'venues-steps-api',
		submitApiAttr: 'venues-submit-api',
		deleteApiAttr: 'venues-delete-api'
	},
	mainContact: {
		wrapper: '.js-activator-my-details-main-contact-section-wrapper',
		button: '.p-activator-portal-my-details_edit-contact-btn',
		stepsApiAttr: 'contact-steps-api',
		submitApiAttr: 'contact-submit-api'
	}
};

const PREFERENCE_MODAL = '#js-preference-modal-modal';
const SELECTOR_FORM = '.p-preference-modal-form';
const SELECTOR_FORM_SUBMIT_BUTTON = '.p-preference-modal-form__submit-btn';
const SELECTOR_FORM_BACK_BUTTON = '.p-preference-modal-form__back-btn';
const SELECTOR_ERROR_CONTAINER = '.p-preference-modal-error-container';
const SELECTOR_ERROR_TEXT = '.error-container-message-text';
const SELECTOR_DISMISS_ERROR = '.js-dismiss-error-button';

const SELECTOR_ERROR_MODAL = '.js-my-activator-details-error-modal';
const SELECTOR_ERROR_MODAL_TEXT = '.error-text';
const SELECTOR_ERROR_MODAL_DISSMISS = '.js-dismiss-error';

const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-preference-modal-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-preference-modal-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-preference-modal-confirm-no';

const SELECTOR_VENUE_EDIT_BUTTON = '.js-edit-venue-btn';
const SELECTOR_VENUE_DELETE_BUTTON = '.js-delete-venue-btn';

const SELECTOR_DELETE_VENUE_MODAL = '.js-delete-venue-modal';
const SELECTOR_DELETE_VENUE_YES = '.js-delete-venue-modal-yes';
const SELECTOR_DELETE_VENUE_NO = '.js-delete-venue-modal-no';

const CLICK_EVENT = 'click';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';
const REFERENCE_VALUE_OBJECT = 'label';

const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;

class ActivatorPortalMyDetails {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		// eslint-disable-next-line unicorn/no-null
		this.currentSection = null;
		// eslint-disable-next-line unicorn/no-null
		this.currentVenue = null;
		// eslint-disable-next-line unicorn/no-null
		this.venueToDelete = null;
		this.answerList = {};
		this.isVenueEditMode = false;
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		// Initialize modal elements
		const preferenceModalHtml = SelectorEngine.findOne(PREFERENCE_MODAL, this._wrapper);
		this.preferenceModal = new Modal(preferenceModalHtml, { backdrop: 'static' });

		this.form = SelectorEngine.findOne(SELECTOR_FORM, this._wrapper);
		this.formSubmitButton = SelectorEngine.findOne(SELECTOR_FORM_SUBMIT_BUTTON, this._wrapper);
		this.formExitButton = SelectorEngine.findOne(SELECTOR_FORM_BACK_BUTTON, this._wrapper);
		this.errorContainer = SelectorEngine.findOne(SELECTOR_ERROR_CONTAINER, this._wrapper);
		this.errorText = SelectorEngine.findOne(SELECTOR_ERROR_TEXT, this.errorContainer);
		this.dismissErrorButton = SelectorEngine.findOne(SELECTOR_DISMISS_ERROR, this.errorContainer);

		this.errorModalHtml = SelectorEngine.findOne(SELECTOR_ERROR_MODAL, this._wrapper);
		this.errorModal = new Modal(this.errorModalHtml, { backdrop: 'static' });
		this.errorModalText = SelectorEngine.findOne(SELECTOR_ERROR_MODAL_TEXT, this.errorModalHtml);
		this.closeErrorModal = SelectorEngine.findOne(SELECTOR_ERROR_MODAL_DISSMISS, this.errorModalHtml);

		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		// Initialize delete venue modal
		const deleteVenueModalHtml = SelectorEngine.findOne(SELECTOR_DELETE_VENUE_MODAL, this._wrapper);
		this.deleteVenueModal = new Modal(deleteVenueModalHtml, { backdrop: 'static' });

		this.deleteVenueYes = SelectorEngine.findOne(SELECTOR_DELETE_VENUE_YES, this._wrapper);
		this.deleteVenueNo = SelectorEngine.findOne(SELECTOR_DELETE_VENUE_NO, this._wrapper);

		// Attach event listeners to all section buttons
		this.attachSectionEventListeners();

		// Attach separate event listeners for venue edit buttons
		this.attachVenueEditEventListeners();

		// Attach separate event listeners for venue delete buttons
		this.attachVenueDeleteEventListeners();

		if (this.closeErrorModal) {
			EventHandler.on(this.closeErrorModal, CLICK_EVENT, () => {
				this.errorModal.hide();
				window.location.reload();
			});
		}

		// Initialize modal event handlers
		this.initModalEventHandlers();
	}

	attachSectionEventListeners() {
		for (const [sectionKey, config] of Object.entries(SECTION_CONFIG)) {
			const sectionWrapper = SelectorEngine.findOne(config.wrapper, this._wrapper);
			if (sectionWrapper) {
				const button = SelectorEngine.findOne(config.button, sectionWrapper);
				if (button) {
					EventHandler.on(button, CLICK_EVENT, () => {
						this.isVenueEditMode = false;
						this.editActivatorPreferences(sectionKey, sectionWrapper, config);
					});
				}
			}
		}
	}

	attachVenueEditEventListeners() {
		const venueSection = SelectorEngine.findOne(SECTION_CONFIG.venues.wrapper, this._wrapper);
		if (venueSection) {
			const venueEditButtons = SelectorEngine.find(SELECTOR_VENUE_EDIT_BUTTON, venueSection);
			for (const button of venueEditButtons) {
				EventHandler.on(button, CLICK_EVENT, (event) => {
					event.preventDefault();
					const venueId = Manipulator.getDataAttribute(button, 'venue-edit-id');
					const venueIndex = Manipulator.getDataAttribute(button, 'venue-edit-index');
					this.isVenueEditMode = true;
					this.editVenue(venueId, venueIndex);
				});
			}
		}
	}

	attachVenueDeleteEventListeners() {
		const venueSection = SelectorEngine.findOne(SECTION_CONFIG.venues.wrapper, this._wrapper);
		if (venueSection) {
			const venueDeleteButtons = SelectorEngine.find(SELECTOR_VENUE_DELETE_BUTTON, venueSection);
			for (const button of venueDeleteButtons) {
				EventHandler.on(button, CLICK_EVENT, (event) => {
					event.preventDefault();
					const venueId = Manipulator.getDataAttribute(button, 'venue-delete-id');
					const venueIndex = Manipulator.getDataAttribute(button, 'venue-delete-index');
					this.openDeleteVenueModal(venueId, venueIndex);
				});
			}
		}
	}

	initModalEventHandlers() {
		EventHandler.on(this.formSubmitButton, CLICK_EVENT, async () => {
			const isFormValid = await this.formGenerator.formValidation();

			if (isFormValid) {
				if (this.isVenueEditMode) {
					this.submitVenueDetails(this.answerList);
				} else {
					this.submitSectionDetails(this.answerList);
				}
			}
		});

		EventHandler.on(this.formExitButton, CLICK_EVENT, () => {
			this.exitConfirmModal.show();
		});

		EventHandler.on(this.exitConfirmYes, CLICK_EVENT, () => {
			this.handleModalExit();
		});

		EventHandler.on(this.exitConfirmNo, CLICK_EVENT, () => {
			this.exitConfirmModal.hide();
		});

		// Delete venue modal event handlers
		EventHandler.on(this.deleteVenueYes, CLICK_EVENT, () => {
			this.confirmDeleteVenue();
		});

		EventHandler.on(this.deleteVenueNo, CLICK_EVENT, () => {
			this.deleteVenueModal.hide();
		});

		if (this.dismissErrorButton) {
			EventHandler.on(this.dismissErrorButton, CLICK_EVENT, () => {
				this.hideError();
				window.location.reload();
			});
		}
	}

	// ===== SECTION EDITING FLOW =====

	async editActivatorPreferences(sectionKey, sectionWrapper, config) {
		// Store current section for later use
		this.currentSection = {
			key: sectionKey,
			wrapper: sectionWrapper,
			stepsApi: Manipulator.getDataAttribute(sectionWrapper, config.stepsApiAttr),
			submitApi: Manipulator.getDataAttribute(sectionWrapper, config.submitApiAttr)
		};

		// Clear previous form and errors
		this.form.innerHTML = '';
		this.hideError();

		// Show modal and fetch form steps
		await this.fetchSectionFormSteps();
	}

	async fetchSectionFormSteps() {
		startLoadingAnimation();
		try {
			if (!this.currentSection?.stepsApi) {
				this.showErrorModal('Steps API not configured for this section');
				stopLoadingAnimation();
				return;
			}

			const response = await Request.get(this.currentSection.stepsApi, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { Steps, error } = response;
			stopLoadingAnimation();

			if (error?.hasError) {
				const errorMessage = error?.message || error?.errorMessage || 'Failed to fetch form steps';
				this.showErrorModal(errorMessage);
				return;
			}

			if (Steps && Steps.length > 0) {
				this.stepsData = Steps;
				this.preferenceModal.show();
			}
		} catch (error) {
			stopLoadingAnimation();
			const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
			this.showErrorModal(errorMessage);
		}
	}

	async submitSectionDetails(requestObject) {
		startLoadingAnimation();
		try {
			if (!this.currentSection?.submitApi) {
				throw new Error('Submit API not configured for this section');
			}

			const response = await Request.post(this.currentSection.submitApi, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { Success, success, Response } = response;

			if (!(Success || success)) {
				stopLoadingAnimation();
				const errorMessage = Response || 'Failed to submit form';
				this.showError(errorMessage);
				return;
			}

			if (Success || success) {
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
			this.showError(errorMessage);
		}
	}

	// ===== VENUE EDITING FLOW =====

	async editVenue(venueId, venueIndex) {
		const venueSection = SelectorEngine.findOne(SECTION_CONFIG.venues.wrapper, this._wrapper);
		const config = SECTION_CONFIG.venues;

		// Store venue context separately
		this.currentVenue = {
			venueId: venueId,
			venueIndex: venueIndex,
			wrapper: venueSection,
			stepsApi: Manipulator.getDataAttribute(venueSection, config.stepsApiAttr),
			submitApi: Manipulator.getDataAttribute(venueSection, config.submitApiAttr)
		};

		// Clear previous form and errors
		this.form.innerHTML = '';
		this.hideError();

		// Show modal and fetch form steps
		await this.fetchVenueFormSteps();
	}

	async fetchVenueFormSteps() {
		startLoadingAnimation();
		try {
			if (!this.currentVenue?.stepsApi) {
				this.showErrorModal('Steps API not configured for venue editing');
				stopLoadingAnimation();
				return;
			}

			const url = `${this.currentVenue.stepsApi}`;

			const response = await Request.get(
				url,
				{ venueId: this.currentVenue.venueId },
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);

			const { Steps, error } = response;
			stopLoadingAnimation();

			if (error?.hasError) {
				const errorMessage = error?.message || error?.errorMessage || 'Failed to fetch venue details';
				this.showErrorModal(errorMessage);
				return;
			}

			if (Steps && Steps.length > 0) {
				this.stepsData = Steps;
				this.preferenceModal.show();
			}
		} catch (error) {
			stopLoadingAnimation();
			const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
			this.showErrorModal(errorMessage);
		}
	}

	async submitVenueDetails(requestObject) {
		startLoadingAnimation();
		try {
			if (!this.currentVenue?.submitApi) {
				throw new Error('Submit API not configured for venue');
			}

			const url = this.currentVenue.submitApi;
			const payload = {
				...requestObject
			};

			const response = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const { Success, success, Response } = response;

			if (!(Success || success)) {
				stopLoadingAnimation();
				const errorMessage = Response || 'Failed to submit form';
				this.showError(errorMessage);
				return;
			}

			if (Success || success) {
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
			this.showError(errorMessage);
		}
	}

	// ===== VENUE DELETION FLOW =====

	openDeleteVenueModal(venueId, venueIndex) {
		// Store venue to delete
		this.venueToDelete = {
			venueId: venueId,
			venueIndex: venueIndex
		};

		// Show delete confirmation modal
		this.deleteVenueModal.show();
	}

	async confirmDeleteVenue() {
		if (!this.venueToDelete?.venueId) {
			this.showErrorModal('Venue ID is not available');
			return;
		}

		const venueSection = SelectorEngine.findOne(SECTION_CONFIG.venues.wrapper, this._wrapper);
		const deleteApi = Manipulator.getDataAttribute(venueSection, SECTION_CONFIG.venues.deleteApiAttr);

		if (!deleteApi) {
			this.showErrorModal('Delete API not configured for venues');
			return;
		}

		startLoadingAnimation();
		try {
			const url = `${deleteApi}?venueId=${this.venueToDelete.venueId}`;

			const response = await Request.post(
				url,
				{ venueId: this.venueToDelete.venueId },
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);

			const { Success, success, error } = response;
			stopLoadingAnimation();

			if (error?.hasError) {
				const errorMessage = error?.message || error?.errorMessage || 'Failed to delete venue';
				this.showErrorModal(errorMessage);
				return;
			}

			if (Success || success) {
				this.deleteVenueModal.hide();
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			const errorMessage = error?.message || error?.errorMessage || 'An unexpected error occurred';
			this.showErrorModal(errorMessage);
		}
	}

	// ===== SHARED METHODS =====

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.form, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			themeColor: 'color-lta-blue',
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			isBackButtonEnabled: false,
			isExitButtonEnabled: true,
			isRenderDependentQuestion: false,
			exitButtonHandler: () => {
				this.exitConfirmModal.show();
			}
		});

		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				if (answerObject[KEY_OBJECT] === 'reference') {
					formatObject[answerObject[KEY_OBJECT]] = answerObject.isOthers
						? answerObject.value
						: answerObject[REFERENCE_VALUE_OBJECT].trim();
				}
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	showError(message) {
		if (this.errorText) {
			this.errorText.innerHTML = message;
		}
		if (this.errorContainer) {
			this.errorContainer.classList.remove(HIDDEN_CLASS);
		}
	}

	hideError() {
		if (this.errorContainer) {
			this.errorContainer.classList.add(HIDDEN_CLASS);
		}
	}

	showErrorModal(error) {
		const message =
			(error && (error.message || error.errorMessage)) || (typeof error === 'string' && error) || 'An error occurred';
		if (this.errorModalText) {
			this.errorModalText.innerHTML = message;
		}
		if (this.errorModal) {
			this.errorModal.show();
		}
	}

	handleModalExit() {
		this.preferenceModal.hide();
		this.exitConfirmModal.hide();
		this.hideError();
		this.form.innerHTML = '';
		this.answerList = {};
		this.isVenueEditMode = false;
	}
}

const globalActivatorPortalMyDetails = new ActivatorPortalMyDetails();
export default globalActivatorPortalMyDetails;
